import styled from '@emotion/styled';

/**
 * Habillage des champs d'un `<AddressInput/>` dans le parcours Habitation, à
 * poser AUTOUR de lui :
 *
 *   <HabitationAddressFields>
 *     <AddressInput value={address} onChange={…} limitFrenchCountry />
 *   </HabitationAddressFields>
 *
 * Pendant de `components/common/AddressFieldsStyled`, et même technique : on
 * cible des classes MUI descendantes, ce qui traverse `AddressInput` sans
 * qu'il ait à exposer la moindre props de style.
 *
 * Fichier distinct, et non réutilisation de l'habillage partagé, parce que
 * l'arrondi n'est PAS le même : Habitation est à 12px, là où les parcours
 * d'inscription portent la « pilule » à 30px avec des champs plus bas.
 * Reprend donc à l'identique l'ancien `ROUND_INPUT_SX` que `AddressStep` et
 * `HousingRecapBox` passaient via la props `textFieldSx`, retirée lors de la
 * refonte du composant (STU-28).
 */
export const HabitationAddressFields = styled.div`
  & .MuiOutlinedInput-root {
    border-radius: 12px;
  }
`;
